import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable } from "rxjs";
import {
	type CreateVirtualTourInput,
	type UpdateVirtualTourInput,
	type VirtualTour,
} from "src/app/schema";
import { ApiService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class VirtualTourService {
	private readonly _httpClient = inject(HttpClient);
	private readonly _api = inject(ApiService);

	public createVirtualTour(
		virtualTour: CreateVirtualTourInput,
	): Observable<VirtualTour> {
		return this._httpClient.post<VirtualTour>(
			`${this._api.inventoryApiEndpoint}/virtual-tour`,
			virtualTour,
		);
	}

	public updateVirtualTour(
		virtualTour: UpdateVirtualTourInput,
	): Observable<VirtualTour> {
		return this._httpClient.put<VirtualTour>(
			`${this._api.inventoryApiEndpoint}/virtual-tour`,
			virtualTour,
		);
	}

	public deleteVirtualTour(
		virtualTour: VirtualTour,
	): Observable<{ id: string }> {
		return this._httpClient.delete<{ id: string }>(
			`${this._api.inventoryApiEndpoint}/virtual-tour/${virtualTour.id}`,
		);
	}
}
